import { API_URL } from "../../shared/constants";
import { emptySplitApi } from "../emptySplit-api";

// Audit-field configuration shape (TSK-OO-007): `fields` is the current
// selection, `available` is the full set of order fields the server offers.
export interface AuditFieldsConfig {
  fields: string[];
  available: string[];
}

export interface AuditFieldsGetResponse {
  status: boolean;
  item: AuditFieldsConfig;
}

export const settingsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    settingsGet: builder.query({
      query: () => ({
        url: `/${API_URL.SETTINGS}/${API_URL.AUTO_CONFIRM}/get`,
        method: "post",
      }),
    }),
    settingsUpdate: builder.mutation<any, any>({
      query: (data: any) => {
        return {
          url: `/${API_URL.SETTINGS}/${API_URL.AUTO_CONFIRM}/update`,
          method: "post",
          body: data,
        };
      },
    }),
    adminEditableFieldsGet: builder.query<any, any>({
      query: () => ({
        url: `/${API_URL.SETTINGS}/admin-editable-fields/get`,
        method: "post",
        body: {},
      }),
    }),
    adminEditableFieldsUpdate: builder.mutation<any, any>({
      query: (data: any) => ({
        url: `/${API_URL.SETTINGS}/admin-editable-fields/update`,
        method: "post",
        body: data,
      }),
    }),
    auditFieldsGet: builder.query<AuditFieldsGetResponse, void>({
      query: () => ({
        url: `/${API_URL.SETTINGS}/${API_URL.AUDIT_FIELDS}/get`,
        method: "post",
        body: {},
      }),
    }),
    auditFieldsUpdate: builder.mutation<any, { fields: string[] }>({
      query: (data) => ({
        url: `/${API_URL.SETTINGS}/${API_URL.AUDIT_FIELDS}/update`,
        method: "post",
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useSettingsGetQuery,
  useSettingsUpdateMutation,
  useAdminEditableFieldsGetQuery,
  useAdminEditableFieldsUpdateMutation,
  useAuditFieldsGetQuery,
  useAuditFieldsUpdateMutation,
} = settingsApi;
